import React, { useState,useEffect  } from "react";
import API_BASE_URL from "../config";
import axios from "axios";
import AlertModal from "../components/AlertModal";
import { useUser } from "../context/UserContext";
import { useAlertModal } from "../hooks/useAlertModal";
import { UNSAFE_getPatchRoutesOnNavigationFunction } from "react-router-dom";

const UserManagement = () => {
  const [activeTab, setActiveTab] = useState("userGameList");
 const [loading, setLoading] = useState(true); // 로딩 상태 추가
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [editedNickname, setEditedNickname] = useState("");
  const [userData, setUserData] = useState([]);
  const [page, setPage] = useState(0); // 페이지 번호
  const [size, setSize] = useState(10); // 페이지 크기
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const { userInfo ,setUserInfo} = useUser();

  // 접속 중 유저용
  const [onlinePage, setOnlinePage] = useState(0);
  const [onlineSize, setOnlineSize] = useState(10);
  const [onlineTotalPages, setOnlineTotalPages] = useState(0);


  const {
    isAlertOpen,
    alertMessage,
    showAlert,
    closeAlert
  } = useAlertModal();

  useEffect(() => {
    axios.get(`${API_BASE_URL}/users?page=${page}&size=${size}&searchTerm=${searchTerm}&username=${userInfo.username}`,{ headers: {
              'X-Frontend-Request': 'true',
         
        }})
      .then((response) => {
        setUsers(response.data.content);
    
        setTotalPages(response.data.totalPages); // 총 페이지 수 설정
      })
      .catch((error) => {
        console.error("유저 목록 불러오기 실패:", error);
      }).finally(() => {
        setLoading(false);
      });
  }, [page,size,searchTerm]);

  useEffect(() => {
    if (activeTab === "userGameList") {
      axios.get(`${API_BASE_URL}/users/online?page=${onlinePage}&size=${onlineSize}&username=${userInfo.username}`,{ headers: {
              'X-Frontend-Request': 'true',
         
        }})
        .then(res => {
          setUserData(res.data.content);
        
          setOnlineTotalPages(res.data.totalPages);
        });
    }
  }, [onlinePage, onlineSize, activeTab]);

  const toggleBlockUser = async (userId) => {
    try {
      const res = await fetch(`${API_BASE_URL}/users/toggle-block?userId=${userId}`, { headers: {
              'X-Frontend-Request': 'true',
         
        },
        method: "POST",
      });
  
      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg);
      }
  
      setUsers(prevUsers =>
        prevUsers.map(user =>
          user.id === userId ? { ...user, blocked: !user.blocked } : user
        )
      );
    } catch (err) {
      showAlert("오류: " + err.message);
    }
  };


  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div id="container">
      <div className="container-inner">
        <h2>유저 관리</h2>

        {/* ✅ 하위 메뉴 */}
        <div className="tab-menu">
          <button className={activeTab === "userGameList" ? "active" : ""} onClick={() => setActiveTab("userGameList")}>
            접속 게임 현황
          </button>
          <button className={activeTab === "userList" ? "active" : ""} onClick={() => setActiveTab("userList")}>
            유저 목록
          </button>
        </div>

        {/* ✅ 접속 게임 현황 */}
        {activeTab === "userGameList" && (
          <div className="user-game-list">
            <table>
              <thead>
                <tr>
                  <th>유저 ID</th>
                  <th>접속 게임</th>
                  <th>보유 금액</th>
                  <th>배팅 금액</th>
                  <th>당첨 금액</th>
                  <th>최근 로그인</th>
                  <th>이벤트 종류</th>
                </tr>
              </thead>
              <tbody>
              { userData.length > 0 ? (
                  <>
                {userData.map((user, index) => (
                  <tr key={index}>
                    <td>{user.username}</td>
                    <td>{user.gameName ? user.gameName: "없음"}</td> {/* gameAPI 객체에서 이름 추출 */}
                    <td>{user.egg.toLocaleString()} 원</td>
                    <td>{user.betAmount.toLocaleString()} 원</td>
                    <td>{user.winAmount.toLocaleString()} 원</td>
                    <td>{user.lastLoginTime.substring(0, 19).replace('T', ' ')}</td>
                    <td>{user.eventType ?? "이벤트 없음"}</td>
                  </tr>
                ))}</>
              ):<></>}

              </tbody>
            </table>
            { userData.length > 0 ? (
                  <>
            <div className="pagination">
                <button
                          disabled={onlinePage === 0}
                          onClick={() => setOnlinePage(onlinePage - 1)}
                        >
                          ◀
                        </button>
                  {Array.from({ length: onlineTotalPages }, (_, i) => (

                    <button
                      key={i}
                      className={onlinePage === i ? "active" : ""}
                      onClick={() => setOnlinePage(i)}
                    >

                      {i + 1}
                    </button>

                    
                  ))}
                    <button
                          disabled={onlinePage === onlineTotalPages - 1}
                          onClick={() => setOnlinePage(onlinePage + 1)}
                        >
                          ▶
                        </button>
                </div></>
                ) :<>
                  <div className="empty-state">
                    <i className="fa-solid fa-user"></i>
                    <p className="title">해당하는 유저가 없습니다</p>
                  </div>
                </>}
          </div>
        )}
        {/* ✅ 유저 목록 */}
        {activeTab === "userList" && (
          <div className="user-list">
              {/* 검색 영역 */}
              <div className="user-list__search">
                <input
                  type="text"
                  placeholder="아이디 또는 닉네임 검색"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-input"
                />
              </div>
            <table>
              <thead>
                <tr>
                  <th>고유번호</th>
                  <th>아이디</th>
                  <th>닉네임</th>
                  <th>등록일</th>
                  <th>최근 로그인</th>
                  <th>관리</th>
                </tr>
              </thead>
              <tbody>
              { users.length > 0 ? (
                  <>
              {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.username}</td>
                    <td>
                      {editingUser === user.id ? (
                        <input
                          type="text"
                          value={editedNickname}
                          onChange={(e) => setEditedNickname(e.target.value)}
                        />
                      ) : (
                        user.nickname
                      )}
                    </td>
                    <td>{new Date(user.registrationDate).toISOString().split('T')[0]}</td>
                    <td>{user.lastLoginDate.substring(0, 19).replace('T', ' ')}</td>
                    <td>
                      <button
                        className={user.blocked ?  "btn-block":"btn-unblock" }
                        onClick={() => toggleBlockUser(user.id)}
                      >
                        {user.blocked ? "차단" : "허용" }
                      </button>
                     
                    </td>
                  </tr>
                ))}</>
              ):<></>}
              </tbody>
            </table>
            
            { users.length > 0 ? (
                  <>
            <div className="pagination">
                <button
                          disabled={page === 0}
                          onClick={() => setPage(page - 1)}
                        >
                          ◀
                        </button>
                  {
                  
                  Array.from({ length: totalPages }, (_, i) => (

                    <button
                      key={i}
                      className={page === i ? "active" : ""}
                      onClick={() => setPage(i)}
                    >

                      {i + 1}
                    </button>

                    
                  ))}
                    <button
                          disabled={page === totalPages - 1}
                          onClick={() => setPage(page + 1)}
                        >
                          ▶
                        </button>
                </div> </>
              ) :<>
                  <div className="empty-state">
                    <i className="fa-solid fa-user"></i>
                    <p className="title">해당하는 유저가 없습니다</p>
                  </div>
                </>}

              </div>
        )}
      </div>
    </div>
  );
};

export default UserManagement;
